<template>
  <div class="form-group" :class="colStyle">
    <Field v-slot="{ errors }"
      :model-value="getValue"
      :name="name"
      :rules="rules">
      <label v-if="!hideLabel" :for="name">{{ label }} <span v-if="isRequired" class="text-danger">*</span></label>
      <slot name="header" />
      <input :id="name"
        :name="name"
        type="file"
        :accept="accept"
        :multiple="multiple"
        :class="{
          'is-invalid': !disabled && hasErrors(errors),
          'form-control': !readOnly,
          'form-control-plaintext': readOnly,
        }"
        :disabled="disabled||readOnly"
        @change="onChange">
      <InvalidFeedback :name="getErrorName" :errors="errors" />
    </Field>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { Field } from 'vee-validate';
import InvalidFeedback from "@/src/components/shared/InvalidFeedback.vue";

type FileInputProps = {
  modelValue?: File | File[] | null;
  name: string;
  label: string;
  rules?: string;
  disabled?: boolean;
  readOnly?: boolean;
  colStyle?: string;
  hideLabel?: boolean;
  accept?: string;
  multiple?: boolean;
}

const props = withDefaults(defineProps<FileInputProps>(), {
  modelValue: null,
  rules: '',
  disabled: false,
  readOnly: false,
  colStyle: 'form-group-standard-6-column-medium-up',
  hideLabel: false,
  accept: '',
  multiple: false,
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: File | File[] | null): void;
  (e: 'change'): void;
}>();

const getValue = computed(() => props.modelValue);
const getErrorName = computed(() => `${props.name}_error`);
const isRequired = computed(() => !!props.rules && props.rules.includes('required'));

function hasErrors(errors: string[]): boolean {
  return (errors || []).length > 0;
}

function onChange(event: Event) {
  const target = event.target as HTMLInputElement;
  const files = target.files ? Array.from(target.files) : [];
  const value = props.multiple ? files : (files[0] ?? null);

  emit('update:modelValue', value);
  emit('change');
}
</script>
